export default __webpack_public_path__ + "static/media/footer-2.388e3b2d.png";